<template>
    <BackofficeLayout :breadcrumb="breadcrumb">
        <v-overlay :value="loading">
            <v-sheet justify-center align-center outlined color="transparent">
                <v-progress-circular indeterminate :size="50">
                </v-progress-circular> </v-sheet
        ></v-overlay>
        <CandidatesApplicant
            v-if="showApplicantComponent"
            @loadingUpdate="loadingProcess"
        />
    </BackofficeLayout>
</template>

<script>
import BackofficeLayout from "@/components/common/BackofficeLayout.vue";
import CandidatesApplicant from "@/components/admin/Candidates/CandidatesApplicant.vue";
import * as services from "@/services";

export default {
    components: {
        BackofficeLayout,
        CandidatesApplicant,
    },
    data() {
        return {
            loading: 0,
            registerFormDetail: null,
            registerPlan: null,
        };
    },
    mounted() {
        this.getRegistrationPlanById();
    },
    methods: {
        loadingProcess(value) {
            if (value == 0) {
                this.loading = 0;
            }
            this.loading += value;
            if (this.loading < 0) this.loading = 0;
        },
        routeToEdit() {
            this.$router.push("/registration/candidates/1/applicant/2");
        },
        async getRegistrationPlanById() {
            try {
                this.loadingProcess(1);
                const { id, plan_id } = this.$route.params;
                const {
                    data: { data },
                } = await services.getRegistrationFormById(id);

                this.registerFormDetail = data.registration_form;
                this.registerPlan = this.registerFormDetail.register_plans.find(
                    (plan) => plan.id == plan_id
                );
            } finally {
                this.loadingProcess(-1);
            }
        },
    },
    computed: {
        
        yearIdParams() {
            return this.$route.params?.id;
        },
        applicantIdParam() {
            return this.$route.params?.applicantId;
        },
        gradePlanIdParam() {
            return this.$route.params?.plan_id;
        },
        
        showApplicantComponent() {
            if (this.yearIdParams && this.applicantIdParam) return true;
            return false;
        },

        breadcrumb() {
            const breadcrumb = [
                {
                    text: this.$t("message.registration_form.candidate_list"),
                    link: "/registration/calendar",
                },
            ];
            if (this.registerFormDetail) {
                breadcrumb.push(
                    {
                        text: `${this.$t("message.common.academic_year")} ${this.registerFormDetail.semester_year}`,
                        link: `/registration/calendar/${this.registerFormDetail.id}`,
                    },
                    {
                        text: `${this.registerPlan.student_year?.[`student_year_name_${this.$i18n.locale}`]} : ${this.registerPlan.program?.[`program_name_${this.$i18n.locale}`]}`,
                        link: `/registration/calendar/${this.registerFormDetail.id}/grade-plans/${this.registerPlan.id}`,
                    },
                    {
                        text: `${this.$t("message.common.applicantInfo")}`,
                        link: `/registration/calendar/${this.registerFormDetail.id}/grade-plans/${this.registerPlan.id}/applicant/${this.applicantIdParam}`,
                    },
                );
                if(this.$route.query.section){
                    if(this.$route.query.section=="basic"){
                        breadcrumb.push(
                            {
                                text: `${this.$t("message.common.edit.basic")}`,
                            }
                        )
                    }else if(this.$route.query.section=="address"){
                        breadcrumb.push(
                            {
                                text: `${this.$t("message.common.edit.address")}`,
                            }
                        )
                    }else if(this.$route.query.section=="parents"){
                        breadcrumb.push(
                            {
                                text: `${this.$t("message.common.edit.parents")}`,
                            }
                        )
                    }else if(this.$route.query.section=="other"){
                        breadcrumb.push(
                            {
                                text: `${this.$t("message.common.edit.other")}`,
                            }
                        )
                    }
                }
            }

            return breadcrumb;
        },
    },
};
</script>

<style scoped lang="scss">
.breadcrumb-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #37323c;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
</style>
